var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"tab",staticClass:"v-tab",class:_vm.clazz,on:{"click":_vm.handleClick}},[_c('span',{staticClass:"v-tab__label"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }